import React, { Suspense } from 'react'

import App from '@/App'
import Layout from '@/components/layouts/Layout'
import { SwapLayout } from '@/components/layouts/Swap'
import { Loading } from '@/components/loading'
import { PATH_NAME } from '@/config'
import Faucet from '@/pages/faucet/faucet'
import { ReferralHub } from '@/pages/referral-hub/ReferralHub'
import { IS_DEV, IS_STAGING } from '@/utils'

import { createBrowserRouter } from 'react-router-dom'

import { RouterErrorElement } from './RouterErrorElement'

const NotFound = React.lazy(() => import('@/pages/not-found'))
const Home = React.lazy(() => import('@/pages/home'))
const ListTransaction = React.lazy(() => import('@/pages/history/ListTransaction'))
const TradeDetail = React.lazy(() => import('@/pages/trade-detail'))
const ShareHandler = React.lazy(() => import('@/pages/share'))
const FixedSwap = React.lazy(() => import('@/pages/fixed-swap/FixedSwap'))
const CreateVault = React.lazy(() => import('@/pages/fixed-swap/CreateVault'))
const VaultDetail = React.lazy(() => import('@/pages/fixed-swap/VaultDetail'))
const VaultHolding = React.lazy(() => import('@/pages/fixed-swap/VaultHolding'))
const VaultHistory = React.lazy(() => import('@/pages/fixed-swap/VaultHistory'))
const ClaimHistory = React.lazy(() => import('@/pages/referral-hub/ClaimHistory'))
const LoadingWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<Loading />}>{children}</Suspense>
)

const router = createBrowserRouter([
  {
    path: PATH_NAME.HOME,
    element: (
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    ),
    errorElement: <RouterErrorElement />,
    children: [
      {
        path: '',
        element: <Layout />,
        children: [
          {
            element: <SwapLayout />,
            children: [
              { index: true, element: <Home /> },
              { path: '', element: <Home /> },
              { path: PATH_NAME.SWAP, element: <Home /> },
              { path: PATH_NAME.FIXED_SWAP, element: <FixedSwap /> },
              { path: PATH_NAME.FIXED_SWAP_DEPOSIT, element: <CreateVault /> },
              { path: `${PATH_NAME.FIXED_SWAP_DEPOSIT_DETAIL}/:depositId`, element: <VaultDetail /> },
              { path: PATH_NAME.FIXED_SWAP_VAULT, element: <VaultHolding /> },
              { path: PATH_NAME.FIXED_SWAP_DEPOSIT_HISTORY, element: <VaultHistory /> },
            ],
          },
          {
            path: PATH_NAME.HISTORY,
            children: [
              { index: true, element: <ListTransaction /> },
              { path: PATH_NAME.TRADE_DETAIL, element: <TradeDetail /> },
            ],
          },
          { path: `${PATH_NAME.TRANSACTION_DETAIL}`, element: <TradeDetail /> },
          {
            path: PATH_NAME.FAUCET,
            children: [
              {
                index: true,
                element:
                  IS_DEV || IS_STAGING ? (
                    <Faucet />
                  ) : (
                    <LoadingWrapper>
                      <NotFound />
                    </LoadingWrapper>
                  ),
              },
            ],
          },
          {
            path: PATH_NAME.SHARE,
            element: (
              <LoadingWrapper>
                <ShareHandler />
              </LoadingWrapper>
            ),
          },
          { path: `${PATH_NAME.REFERRAL_HUB}/:code?`, element: <ReferralHub /> },
          { path: `${PATH_NAME.CLAIM_HISTORY}/:walletAddress`, element: <ClaimHistory /> },

          {
            path: '*',
            element: (
              <LoadingWrapper>
                <NotFound />
              </LoadingWrapper>
            ),
          },
        ],
      },
    ],
  },
])

export default router
